export enum ModifierType {
    'BASE'='Base',
    'MODIFIER'='MODIFIER',
    'TEMPORARY'='TEMPORARY',
    'CLASSSKILL'='CLASSSKILL',
}